import { Lightbulb, Search, SmartToy } from "@mui/icons-material";
import theme from "../theme";

export const modules = [
  {
    id: "generate-insights",
    title: "Generate Insight",
    description: "Comprehensive Market Analysis",
    icon: Lightbulb,
    gradient: theme.palette.linearGradient.gradientSecondary,
    accentColor: theme.palette.primary.brandSecondary,
    features: [
      "Market trend and overview",
      "Supplier insights",
      "Cost drivers insights",
      "Industry and category news",
      "Financial performance",
    ],
    route: "/GenerateInsights",
    requiresPermission: null,
    hasSubModules: false,
  },
  {
    id: "generate-suppliers",
    title: "Generate Suppliers",
    description: "Supplier discovery",
    icon: Search,
    gradient: theme.palette.linearGradient.gradientTiffanyBlue,
    accentColor: theme.palette.secondary.tiffanyBlue,
    features: ["Supplier Finder Insights"],
    route: "/GenerateSuppliers",
    requiresPermission: "showSupplierFinder",
    hasSubModules: false,
  },
  {
    id: "ai-toolkit",
    title: "AI Toolkit",
    description: "AI-driven document processing",
    icon: SmartToy,
    gradient: theme.palette.linearGradient.gradientLawnGreen,
    accentColor: theme.palette.secondary.lawnGreen,
    features: [
      { text: "Process iteration", requiresSubModule: "Iterator" },
      { text: "Process of Redaction", requiresSubModule: "Redaction" },
      { text: "Multi-language translation", requiresSubModule: "Translator" },
    ],
    route: null,
    requiresPermission: "showAIToolkit",
    hasSubModules: true,
    getSubModules: (accountInfo) => {
      const { getModules } = require("./accountPermission");
      return getModules(accountInfo);
    },
  },
];
